import React, { Component } from "react";
import "./editor.scss";
import "./print.scss";
import { propertyUtil } from "views/Pma/PropertyUtil";

class ColorHotBoxes extends Component {
  componentDidMount() {
    if (this.props.printVersion) {
      require("./print.scss");
    } else {
      require("./editor.scss");
    }
  }

  formatValue = (value, category) => {
    const { roundSalePrice } = propertyUtil;
    if (category === "Sale Prices") {
      //console.log("sale prices", value);
      return `${roundSalePrice(value).toLowerCase()}`;
    } else if (category === "Days to Sell") {
      return `${Math.round(value)}`;
    } else if (category === "Square Ft") {
      return `$${Number(value)}`;
    } else if (category === "Homes for Sale") {
      return `${value}`;
    } else if (category === "% Received of Asking") {
      return `${Math.round(value)}%`;
    }
  };

  formatArrow = (perc, color) => {
    perc = +perc;
    const { mlsAreaID } = this.props.currentArea;

    if (perc > 0) {
      if (color === "white") {
        return (
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/retro_arrows_plus_white-double-up.png"
            alt="White Up Arrow"
            className="white-arrow"
          />
        );
      } else {
        return (
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/retro_arrows_plus_blk-double-up.png"
            alt="Black Up Arrow"
            className="black-arrow"
          />
        );
      }
    } else if (perc < 0) {
      if (color === "white") {
        return (
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/retro_arrows_plus_white-double-down.png"
            alt="White Down Arrow"
            className="white-arrow"
          />
        );
      } else {
        return (
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/retro_arrows_plus_blk-double-down.png"
            alt="Black Down Arrow"
            className="black-arrow"
          />
        );
      }
    } else if (perc == 0) {
      if (color === "white") {
        return (
          <span
            className={`no-change-text ${
              color === "black" && "black-no-change-text"
            }`}
          >
            No Change
          </span>
        );
      } else {
        return (
          <span
            className={`no-change-text ${
              color === "black" && "black-no-change-text"
            }`}
          >
            No Change
          </span>
        );
      }
    }
  };
  formatPercChange = (perc, color) => {
    if (perc > 0) {
      return <span className="trend-text">Up {Math.abs(perc)}%</span>;
    } else if (perc < 0) {
      return <span className="trend-text">Down {Math.abs(perc)}%</span>;
    } else {
      if (color === "white") {
        return (
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/retro_arrows_plus_white-slash-zero.png"
            alt="White Slash Zero"
            className="slash-zero"
          />
        );
      } else {
        return (
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/retro_arrows_plus_blk-slash-zero.png"
            alt="Black Slash Zero"
            className="slash-zero"
          />
        );
      }
    }
  };
  createNeighborhoodName = (neighborhood) => {
    const { mlsAreaID } = this.props.currentArea;
    if (mlsAreaID === "CCA-5900E") {
      return "Black Diamond & Chaparral Springs";
    } else if (mlsAreaID === "CCA-4500H") {
      return "Diablo West / Rancho Ramon / Las Lomitas";
    } else if (mlsAreaID === "CCA-4400AG") {
      return "in Your Neighborhood";
    } else if (neighborhood && neighborhood.length > 56) {
      return "Your Neighborhood";
    } else {
      return neighborhood;
    }
  };

  determineComparison = () => {
    const { infinityCheck } = propertyUtil;
    function calculateDiff(curr, prev) {
      if (curr === "0" && prev === "0") {
        return "0";
      } else if (curr === "0") {
        return -100;
      } else if (prev === "0") {
        return 100;
      } else {
        curr = Math.round(curr);
        prev = Math.round(prev);
        let res = infinityCheck(
          Math.round(((curr - prev) / Math.abs(prev)) * 100)
        );
        return res;
      }
    }
    const {
      quarterlyAreaTable,
      currentArea,
      useCity,
      quarterlyCityTable,
      agentData,
      useSecondMarketIndicators,
      useSeparatedPropertyTypesCondoTownhouse,
      useSeparatedPropertyTypesCondos,
      useSeparatedPropertyTypesTownhouses,
    } = this.props;

    const { listgenUserID } = agentData;
    const { marketHighLightsData, marketTrends } = quarterlyAreaTable;

    const { keyMarketIndicatorAveragesForCity } = quarterlyCityTable;
    const { mlsAreaID } = currentArea;

    let dataObj = {
      compareDays: null,
      salePriceDiff: null,
      salePriceDataPoint: null,
      receivedPerc: null,
      receivedDataPoint: null,
      daysToSellPerc: null,
      daysToSellDataPoint: null,
      unitsSoldPerc: null,
      unitsSoldDataPoint: null,
      previousUnitsSoldDataPoint: null,
      sqftPercDiff: null,
      sqftDataPoint: null,
      monthComparison: null,
      highestSalePrice: null,
      useMedianSalePrice: false,
      useSingleFamilyHomes: false,
    };
    const {
      current180DaysAvgSalePrice,
      previous180DaysAvgSalePrice,
      current180DaysMedianSalePrice,
      previous180DaysMedianSalePrice,
      current180DaysPercentReceivedOfAsking,
      previous180DaysPercentReceivedOfAsking,
      current180DaysAvgDOM,
      previous180DaysAvgDOM,
      current180DaysUnitsSold,
      previous180DaysUnitsSold,
      current180DaysPricePerSqFt,
      previous180DaysPricePerSqFt,
      current90DaysMedianSalePrice,
      previous90DaysMedianSalePrice,
      median180DaysPercentage,
      current90DaysAvgSalePrice,
      previous90DaysAvgSalePrice,
      current90DaysPercentReceivedOfAsking,
      previous90DaysPercentReceivedOfAsking,
      current90DaysAvgDOM,
      previous90DaysAvgDOM,
      current90DaysUnitsSold,
      previous90DaysUnitsSold,
      current90DaysPricePerSqFt,
      previous90DaysPricePerSqFt,
      median12MonthsPercentage,
      last12MonthsAverageSalePrice,
      previous12MonthsAverageSalePrice,
      last12MonthsMedianSalePrice,
      previous12MonthsMedianSalePrice,
      last12MonthsPercentReceivedOfAsking,
      previous12MonthsPercentReceivedOfAsking,
      last12MonthsPricePerSqFt,
      previous12MonthsPricePerSqFt,
      previous12MonthsUnitsSold,
    } = marketHighLightsData;

    if (listgenUserID === "102548" || listgenUserID === "105227") {
      dataObj.useMedianSalePrice = true;
    }

    let use6Months = false;
    let use6MonthsVsLastYear6Months = true;

    let use12MonthComparison = false;

    if (current180DaysAvgSalePrice == "0") {
      use12MonthComparison = true;
      use6MonthsVsLastYear6Months = false;
    }
    // if (
    //   listgenUserID === "102548" ||
    //   listgenUserID === "102660" ||
    //   listgenUserID === "104480"
    // ) {
    //   use6MonthsVsLastYear6Months = false;
    //   use12MonthComparison = true;
    // }

    if (useCity) {
      //if los olivos or Buellton

      const {
        keyMarketIndicatorAveragesForCity,
        keyMarketIndicatorAveragesPercentageForCity,
      } = quarterlyCityTable;
      let currSix = keyMarketIndicatorAveragesForCity.filter(
        (term) => term.NameOfTerm === "CurrentSixMonths"
      )[0];
      let prevSix = keyMarketIndicatorAveragesForCity.filter(
        (term) => term.NameOfTerm === "PreviousSixMonths"
      )[0];

      const {
        AverageDaysOnMarket: currAverageDaysOnMarket,
        AveragePercentOfReceiving: currAveragePercentOfReceiving,
        AveragePricePerSqFt: currAveragePricePerSqFt,
        AverageSalePrice: currAverageSalePrice,
        NameOfTerm: currNameOfTerm,
        NumberOfListings: currNumberOfListings,
      } = currSix;
      const {
        AverageDaysOnMarket: prevAverageDaysOnMarket,
        AveragePercentOfReceiving: prevAveragePercentOfReceiving,
        AveragePricePerSqFt: prevAveragePricePerSqFt,
        AverageSalePrice: prevAverageSalePrice,
        NameOfTerm: prevNameOfTerm,
        NumberOfListings: prevNumberOfListings,
      } = prevSix;

      dataObj.compareDays = "6 Months";
      dataObj.monthComparison = 6;
      dataObj.salePriceDataPoint = currAverageSalePrice;
      dataObj.salePriceDiff = calculateDiff(
        currAverageSalePrice,
        prevAverageSalePrice
      );
      dataObj.receivedDataPoint = currAveragePercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currAveragePercentOfReceiving,
        prevAveragePercentOfReceiving
      );
      dataObj.sqftDataPoint = currAveragePricePerSqFt;
      dataObj.sqftPercDiff = calculateDiff(
        currAveragePricePerSqFt,
        prevAveragePricePerSqFt
      );
      dataObj.daysToSellDataPoint = currAverageDaysOnMarket;
      dataObj.daysToSellPerc = calculateDiff(
        currAverageDaysOnMarket,
        prevAverageDaysOnMarket
      );
      dataObj.unitsSoldDataPoint = currNumberOfListings;
      dataObj.unitsSoldPerc = calculateDiff(
        currNumberOfListings,
        prevNumberOfListings
      );

      return dataObj;
    }
    if (useSeparatedPropertyTypesTownhouses &&
      (mlsAreaID === "xSMA-390" || mlsAreaID === "SMA-392")
    ) {
      // 6 month vs same 6 months last year Townhouses
      const {
        marketTrendsTH: marketTrendsArea,
        marketTrendsPercentageTH: marketTrendsPercArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "6-Months Trending"
      )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage"
      )[0];

      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending"
      )[0];

      dataObj.compareDays = "6MonthsVSLastYear6Months";
      dataObj.monthComparison = 6;

      dataObj.salePriceDataPoint = currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgSalePrice
        : calculateDiff(
            currentYearObjArea.AvgSalePrice,
            pastYearObjArea.AvgSalePrice
          );

      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;
      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currentYearObjArea.AvgPercentOfReceiving,
        pastYearObjArea.AvgPercentOfReceiving
      );

      dataObj.daysToSellPerc = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgDaysOnMarket
        : calculateDiff(
            currentYearObjArea.AvgDaysOnMarket,
            pastYearObjArea.AvgDaysOnMarket
          );

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageNumberOfHomesSold
        : calculateDiff(
            currentYearObjArea.HomesSold,
            pastYearObjArea.HomesSold
          );

      dataObj.sqftDataPoint = currentYearObjArea.AvgPricePerSqFt;
      dataObj.sqftPercDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgPricePerSqFt
        : calculateDiff(
            currentYearObjArea.AvgPricePerSqFt,
            pastYearObjArea.AvgPricePerSqFt
          );

      return dataObj;
    } else if (
      useSeparatedPropertyTypesCondos &&
      (mlsAreaID === "xSMA-390" ||
        mlsAreaID === "SMA-392" ||
        mlsAreaID === "xCCA-4500F")
    ) {
      // 6 month vs same 6 months last year

      const {
        marketTrendsCND: marketTrendsArea,
        marketTrendsPercentageCND: marketTrendsPercArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "6-Months Trending"
      )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage"
      )[0];

      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending"
      )[0];

      dataObj.compareDays = "6MonthsVSLastYear6Months";
      dataObj.monthComparison = 6;

      dataObj.salePriceDataPoint = currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgSalePrice
        : calculateDiff(
            currentYearObjArea.AvgSalePrice,
            pastYearObjArea.AvgSalePrice
          );

      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;
      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currentYearObjArea.AvgPercentOfReceiving,
        pastYearObjArea.AvgPercentOfReceiving
      );

      dataObj.daysToSellPerc = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgDaysOnMarket
        : calculateDiff(
            currentYearObjArea.AvgDaysOnMarket,
            pastYearObjArea.AvgDaysOnMarket
          );

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageNumberOfHomesSold
        : calculateDiff(
            currentYearObjArea.HomesSold,
            pastYearObjArea.HomesSold
          );

      dataObj.sqftDataPoint = currentYearObjArea.AvgPricePerSqFt;
      dataObj.sqftPercDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgPricePerSqFt
        : calculateDiff(
            currentYearObjArea.AvgPricePerSqFt,
            pastYearObjArea.AvgPricePerSqFt
          );

      return dataObj;
    } else if (
      useSeparatedPropertyTypesCondoTownhouse &&
      (mlsAreaID === "xSMA-390" || mlsAreaID === "SMA-392")
    ) {
      // 6 month vs same 6 months last year
      const {
        marketTrendsCNDTH: marketTrendsArea,
        marketTrendsPercentageCNDTH: marketTrendsPercArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "6-Months Trending"
      )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage"
      )[0];

      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending"
      )[0];

      dataObj.compareDays = "6MonthsVSLastYear6Months";
      dataObj.monthComparison = 6;

      dataObj.salePriceDataPoint = currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgSalePrice
        : calculateDiff(
            currentYearObjArea.AvgSalePrice,
            pastYearObjArea.AvgSalePrice
          );

      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;
      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currentYearObjArea.AvgPercentOfReceiving,
        pastYearObjArea.AvgPercentOfReceiving
      );

      dataObj.daysToSellPerc = currentYearAreaPerc.PercentageAvgDaysOnMarket;

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc.PercentageNumberOfHomesSold;

      dataObj.sqftDataPoint = currentYearObjArea.AvgPricePerSqFt;
      dataObj.sqftPercDiff = currentYearAreaPerc.PercentageAvgPricePerSqFt;

      return dataObj;
    } else if (
      !useSeparatedPropertyTypesCondoTownhouse &&
      !useSeparatedPropertyTypesCondos &&
      !useSeparatedPropertyTypesTownhouses &&
      mlsAreaID === "SMA-392"
    ) {
      dataObj.singleFamilyHomes = true;
      console.log("useSingleFamilyHomes");
      // 6 month vs same 6 months last year
      const {
        marketTrendsSFR: marketTrendsArea,
        marketTrendsPercentageSFR: marketTrendsPercArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "6-Months Trending"
      )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage"
      )[0];

      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending"
      )[0];

      dataObj.compareDays = "6MonthsVSLastYear6Months";
      dataObj.monthComparison = 6;

      dataObj.salePriceDataPoint = currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgSalePrice
        : calculateDiff(
            currentYearObjArea.AvgSalePrice,
            pastYearObjArea.AvgSalePrice
          );

      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;
      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currentYearObjArea.AvgPercentOfReceiving,
        pastYearObjArea.AvgPercentOfReceiving
      );

      dataObj.daysToSellPerc = currentYearAreaPerc.PercentageAvgDaysOnMarket;

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc.PercentageNumberOfHomesSold;

      dataObj.sqftDataPoint = currentYearObjArea.AvgPricePerSqFt;
      dataObj.sqftPercDiff = currentYearAreaPerc.PercentageAvgPricePerSqFt;

      return dataObj;
    } else if (use6MonthsVsLastYear6Months) {
      // 6 month vs same 6 months last year

      const {
        marketTrends: marketTrendsArea,
        marketTrendsPercentage: marketTrendsPercArea,
        graphAverages: graphAveragesArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "6-Months Trending"
      )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage"
      )[0];

      if (!currentYearAreaPerc) {
      }

      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Same 6-Months Last Year Trending"
      )[0];
      dataObj.compareDays = "6MonthsVSLastYear6Months";
      dataObj.monthComparison = 6;
      if (dataObj.useMedianSalePrice) {
        dataObj.salePriceDataPoint = current180DaysMedianSalePrice;
        dataObj.salePriceDiff = median180DaysPercentage;
      } else {
        dataObj.salePriceDataPoint = currentYearObjArea.AvgSalePrice;
        dataObj.salePriceDiff = currentYearAreaPerc
          ? currentYearAreaPerc.PercentageAvgSalePrice
          : calculateDiff(
              currentYearObjArea.AvgSalePrice,
              pastYearObjArea.AvgSalePrice
            );
      }

      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;

      dataObj.daysToSellPerc = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgDaysOnMarket
        : calculateDiff(
            currentYearObjArea.AvgDaysOnMarket,
            pastYearObjArea.AvgDaysOnMarket
          );

      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = currentYearAreaPerc
        ? Math.round(currentYearAreaPerc.PercentageAvgPercentOfReceiving)
        : calculateDiff(
            currentYearObjArea.AvgPercentOfReceiving,
            pastYearObjArea.AvgPercentOfReceiving
          );

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc.PercentageNumberOfHomesSold;

      dataObj.sqftDataPoint = currentYearObjArea.AvgPricePerSqFt;
      dataObj.sqftPercDiff = currentYearAreaPerc
        ? currentYearAreaPerc.PercentageAvgPricePerSqFt
        : calculateDiff(
            currentYearObjArea.AvgPricePerSqFt,
            pastYearObjArea.AvgPricePerSqFt
          );

      return dataObj;
    } else if (
      current180DaysUnitsSold < 1 ||
      +previous180DaysUnitsSold < 1 ||
      use12MonthComparison
    ) {
      // 1Year Trending" and "Past 1 Year Trending"

      const {
        marketTrends: marketTrendsArea,
        marketTrendsPercentage: marketTrendsPercArea,
        graphAverages: graphAveragesArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "1-Year Trending"
      )[0];

      // let currentYearObjArea = marketTrendsArea.filter(
      //   (obj) => obj.TrendName === "1 Year Trends Percentage"
      // )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "1 Year Trends Percentage"
      )[0];

      const pastYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "Past 1-Year Trending"
      )[0];

      dataObj.compareDays = "12 Months";
      dataObj.monthComparison = 12;
      dataObj.salePriceDataPoint = dataObj.useMedianSalePrice
        ? last12MonthsMedianSalePrice
        : currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = dataObj.useMedianSalePrice
        ? median12MonthsPercentage
        : currentYearAreaPerc.PercentageAvgSalePrice;
      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;
      dataObj.receivedDataPoint = currentYearObjArea.AvgPercentOfReceiving;
      dataObj.receivedPerc = calculateDiff(
        currentYearObjArea.AvgPercentOfReceiving,
        pastYearObjArea.AvgPercentOfReceiving
      );

      dataObj.daysToSellPerc = currentYearAreaPerc.PercentageAvgDaysOnMarket;

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.previousUnitsSoldDataPoint = pastYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc.PercentageNumberOfHomesSold;

      dataObj.sqftDataPoint = last12MonthsPricePerSqFt;
      dataObj.sqftPercDiff = calculateDiff(
        last12MonthsPricePerSqFt,
        previous12MonthsPricePerSqFt
      );

      return dataObj;
    } else if (
      use6Months ||
      +current90DaysUnitsSold < 1 ||
      +previous90DaysUnitsSold < 1 ||
      mlsAreaID === "156" ||
      mlsAreaID === "SBA-20FRes"
    ) {
      dataObj.compareDays = "6 Months";
      dataObj.monthComparison = 6;
      dataObj.salePriceDataPoint = current180DaysAvgSalePrice;
      dataObj.salePriceDiff = calculateDiff(
        current180DaysAvgSalePrice,
        previous180DaysAvgSalePrice
      );
      dataObj.receivedDataPoint = current180DaysPercentReceivedOfAsking;
      dataObj.receivedPerc = calculateDiff(
        current180DaysPercentReceivedOfAsking,
        previous180DaysPercentReceivedOfAsking
      );
      dataObj.sqftDataPoint = current180DaysPricePerSqFt;
      dataObj.sqftPercDiff = calculateDiff(
        current180DaysPricePerSqFt,
        previous180DaysPricePerSqFt
      );
      dataObj.daysToSellDataPoint = current180DaysAvgDOM;
      dataObj.daysToSellPerc = calculateDiff(
        current180DaysAvgDOM,
        previous180DaysAvgDOM
      );
      dataObj.unitsSoldDataPoint = current180DaysUnitsSold;
      dataObj.previousUnitsSoldDataPoint = previous180DaysUnitsSold;
      dataObj.unitsSoldPerc = calculateDiff(
        current180DaysUnitsSold,
        previous180DaysUnitsSold
      );

      return dataObj;
    } else {
      dataObj.compareDays = "90 Days";
      dataObj.monthComparison = 6;
      dataObj.salePriceDataPoint = current90DaysAvgSalePrice;
      dataObj.salePriceDiff = calculateDiff(
        current90DaysAvgSalePrice,
        previous90DaysAvgSalePrice
      );
      dataObj.receivedDataPoint = current90DaysPercentReceivedOfAsking;
      dataObj.receivedPerc = calculateDiff(
        current90DaysPercentReceivedOfAsking,
        previous90DaysPercentReceivedOfAsking
      );

      dataObj.sqftDataPoint = current90DaysPricePerSqFt;
      dataObj.sqftPercDiff = calculateDiff(
        current90DaysPricePerSqFt,
        previous90DaysPricePerSqFt
      );

      dataObj.daysToSellDataPoint = current90DaysAvgDOM;
      dataObj.daysToSellPerc = calculateDiff(
        current90DaysAvgDOM,
        previous90DaysAvgDOM
      );
      dataObj.unitsSoldDataPoint = current90DaysUnitsSold;
      dataObj.previousUnitsSoldDataPoint = previous90DaysUnitsSold;
      dataObj.unitsSoldPerc = calculateDiff(
        current90DaysUnitsSold,
        previous90DaysUnitsSold
      );

      return dataObj;
    }
  };
  render() {
    const { printVersion, currentArea, quarterlyAreaTable, agentData } =
      this.props;
    const { mlsAreaID } = currentArea;
    const { listgenUserID } = agentData;
    const {
      createNeighborhoodName,
      formatValue,
      formatArrow,
      formatPercChange,
    } = this;
    const { mlsNeighborhood } = currentArea;
    const determineComparison = this.determineComparison();
    console.log(this.props);
    let currentYearObjArea;
    let currentYearAreaPerc;
    let pastYearObjArea;
    const {
      marketTrends: marketTrendsArea,
      marketTrendsPercentage: marketTrendsPercArea,
      graphAverages: graphAveragesArea,
      highestSalePricePast6Months,

      marketTrendsSFR: marketTrendsAreaSFH,
      marketTrendsPercentageSFR: marketTrendsPercAreaSFH,
      graphAveragesSFR: graphAveragesAreaSFH,
    } = quarterlyAreaTable;
    currentYearObjArea = marketTrendsArea.filter(
      (obj) => obj.TrendName === "6-Months Trending"
    )[0];
    currentYearAreaPerc = marketTrendsPercArea.filter(
      (obj) => obj.TrendPercentageName === "Same 6 Months Trends Percentage"
    )[0];
    pastYearObjArea = marketTrendsArea.filter(
      (obj) => obj.TrendName === "Same 6-Months Last Year Trending"
    )[0];

    let hotBoxStyles;

    let showSubtitle = true;
    if (mlsAreaID === "ALA-3900AK") {
      showSubtitle = false;
      hotBoxStyles = "no-margin-color-hot-boxes";
    }
    return (
      <div
        className={`
          ${
            printVersion
              ? "print-color-hot-boxes-container"
              : "editor-color-hot-boxes-container"
          } ${hotBoxStyles}`}
      >
        <div className="hot-boxes-background-image-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/102925_new-hotbox_shapes_lg.png"
            alt="Market Averages Background"
            className="hot-boxes-background-image"
          />
        </div>
        <div className="color-hot-boxes-header">
          <div className="color-hot-boxes-header-text">Trends That Matter</div>
          {showSubtitle ? (
            <div className="color-hot-boxes-subtitle">
              {createNeighborhoodName(mlsNeighborhood)}{" "}
              {determineComparison.singleFamilyHomes
                ? `(Single Family Homes)`
                : ""}
            </div>
          ) : (
            <div className="color-hot-boxes-subtitle"></div>
          )}
        </div>
        <div className="color-hot-boxes-key-market-container">
          <div className="color-hot-boxes-key-market-item">
            <p>Key Market Averages</p>
          </div>
          {determineComparison.compareDays === "12 Months" ? (
            <div className="color-hot-boxes-key-market-item">
              <p>Last 12 Months vs</p>
              <p>Same 12 Months Last Year</p>
            </div>
          ) : (
            <div className="color-hot-boxes-key-market-item">
              <p>Last 6 Months vs</p>
              <p>Same 6 Months Last Year</p>
            </div>
          )}
        </div>
        <div className="color-hot-boxesy-key-market-divider" />
        <div className="color-hot-boxes-grid">
          <div className="hot-box hot-box-sale-price">
            <div className="hot-box-label">
              {determineComparison.useMedianSalePrice
                ? "Median Sale Price"
                : "Sale Price"}
            </div>
            <div className="hot-box-value">
              {formatValue(
                determineComparison.salePriceDataPoint,
                "Sale Prices"
              )}
            </div>
            <div className="hot-box-trend">
              {formatArrow(determineComparison.salePriceDiff, "white")}
              {formatPercChange(determineComparison.salePriceDiff, "white")}
            </div>
            {determineComparison.salePriceDiff > 0 && (
              <div className="hot-box-advantage sale-price-advantage">
                <p>Seller's</p> <p>Advantage</p>
              </div>
            )}
          </div>

          <div className="hot-box hot-box-days-on-market">
            <div className="hot-box-label">
              <p>Days</p>
              <p>On Market</p>
            </div>

            <div className="hot-box-value">
              {formatValue(
                determineComparison.daysToSellDataPoint,
                "Days to Sell"
              )}
            </div>
            <div className="hot-box-trend">
              {formatArrow(determineComparison.daysToSellPerc, "black")}
              {formatPercChange(determineComparison.daysToSellPerc, "black")}
            </div>
            {determineComparison.daysToSellPerc <= -2 && (
              <div className="hot-box-advantage days-on-market-advantage">
                <p>Seller's</p> <p>Advantage</p>
              </div>
            )}
          </div>

          <div className="hot-box hot-box-units-sold">
            <div className="hot-box-label">Units Sold</div>
            <div className="hot-box-value">
              {formatValue(
                determineComparison.unitsSoldDataPoint,
                "Homes for Sale"
              )}
            </div>
            <div className="hot-box-trend">
              {formatArrow(determineComparison.unitsSoldPerc, "black")}
              {formatPercChange(determineComparison.unitsSoldPerc, "black")}
            </div>
            {determineComparison.unitsSoldPerc >= 25 && (
              <div className="hot-box-advantage units-sold-advantage">
                <p>Seller's</p> <p>Advantage</p>
              </div>
            )}
          </div>

          <div className="hot-box hot-box-price-per-sqft">
            <div className="hot-box-label">Price Per Square Foot</div>
            <div className="hot-box-value-container">
              <div className="hot-box-value">
                {formatValue(determineComparison.sqftDataPoint, "Square Ft")}
              </div>
              <div className="hot-box-trend">
                {formatArrow(determineComparison.sqftPercDiff, "white")}
                {formatPercChange(determineComparison.sqftPercDiff, "white")}
              </div>
            </div>
            {determineComparison.sqftPercDiff >= 1 && (
              <div className="hot-box-advantage price-per-sqft-advantage">
                <p>Seller's</p> <p>Advantage</p>
              </div>
            )}
          </div>

          <div className="hot-box hot-box-percent-received">
            <div className="hot-box-label">% Received of Asking</div>
            <div className="hot-box-value-container">
              {" "}
              <div className="hot-box-value">
                {formatValue(
                  determineComparison.receivedDataPoint,
                  "% Received of Asking"
                )}
              </div>
              <div className="hot-box-trend">
                {formatArrow(determineComparison.receivedPerc, "black")}
                {formatPercChange(determineComparison.receivedPerc, "black")}
              </div>
            </div>
            {(determineComparison.receivedPerc >= 2 ||
              determineComparison.receivedDataPoint > 100) && (
              <div className="hot-box-advantage percent-received-advantage">
                <p>Seller's</p> <p>Advantage</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ColorHotBoxes;
